import { render, staticRenderFns } from "./stackbar.vue?vue&type=template&id=2dbca627&scoped=true&"
import script from "./stackbar.vue?vue&type=script&lang=js&"
export * from "./stackbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbca627",
  null
  
)

export default component.exports